// extracted by mini-css-extract-plugin
export default {"modal":"ProductModels__modal___Rykqr","accordion":"ProductModels__accordion___KanUE"};